import { render } from "./CoverageMainList.vue?vue&type=template&id=0cf74560&scoped=true"
import script from "./CoverageMainList.vue?vue&type=script&lang=js"
export * from "./CoverageMainList.vue?vue&type=script&lang=js"

import "./CoverageMainList.vue?vue&type=style&index=0&id=0cf74560&scoped=true&lang=css"

import exportComponent from "C:\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Controller\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cf74560"]])

export default __exports__